<div class="splash-content">
    <div class="splash-logo-wrapper">
        <img *ngIf="logoUrl" [src]="logoUrl || flooriLogo" alt="company logo" loading="lazy" />
    </div>
    <div class="splash-tile-loader">
        <div class="splash-tile-row">
            <div class="splash-tile splash-tile--1"></div>
            <div class="splash-tile splash-tile--2"></div>
            <div class="splash-tile splash-tile--3"></div>
        </div>
        <div class="splash-tile-row">
            <div class="splash-tile splash-tile--4"></div>
            <div class="splash-tile splash-tile--center">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 12h18M12 3v18" />
                </svg>
            </div>
            <div class="splash-tile splash-tile--5"></div>
        </div>
        <div class="splash-tile-row">
            <div class="splash-tile splash-tile--6"></div>
            <div class="splash-tile splash-tile--7"></div>
            <div class="splash-tile splash-tile--8"></div>
        </div>
    </div>
    @if (flooriIoLinkEnable()) {
    <p class="text-s powered-label">Powered by ActumLab</p>
    }
</div>
